import type { JSX } from 'react'

import { IconButton, SmileIcon } from '@buffer-mono/popcorn'

import { EmojiPicker } from '~publish/components/EmojiPicker'
import type { BufferEditor } from '~publish/legacy/editor/BufferEditor/types.plate'
import { useEmojiInsert } from '~publish/legacy/editor/plugins/emoji'

export function ComposerEmojiButton({
  editor,
}: {
  editor: BufferEditor
}): JSX.Element {
  const insertEmoji = useEmojiInsert({ editor })

  return (
    <EmojiPicker onEmojiSelect={insertEmoji}>
      <IconButton
        data-testid="emoji-picker-button"
        label="Select emoji"
        variant="tertiary"
        tooltip="Select emoji"
      >
        <SmileIcon />
      </IconButton>
    </EmojiPicker>
  )
}
